export const NOSTIUM_BUTTON_SELECTOR = "body > button";
const NOSTIUM_LABEL_HINTS = ["reserveer", "reservering", "nostium"];

const hasNostiumLabelHint = (button: HTMLButtonElement) => {
  const label = [
    button.textContent,
    button.getAttribute("aria-label"),
    button.getAttribute("title"),
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  return NOSTIUM_LABEL_HINTS.some((hint) => label.includes(hint));
};

export const TABLET_MIN_WIDTH = 768;
export const DESKTOP_MIN_WIDTH = 1024;

export const getNostiumButton = () => {
  const directBodyButtons = Array.from(document.querySelectorAll<HTMLButtonElement>(NOSTIUM_BUTTON_SELECTOR));

  return (
    directBodyButtons.find(hasNostiumLabelHint) ??
    directBodyButtons[0] ??
    null
  );
};

export const getFallbackNostiumButtonSize = (viewportWidth: number) => {
  if (viewportWidth < TABLET_MIN_WIDTH) return 40;
  if (viewportWidth < DESKTOP_MIN_WIDTH) return 32;
  return 40;
};

export const getFallbackNostiumBottomOffset = (viewportWidth: number) => {
  if (viewportWidth < TABLET_MIN_WIDTH) return 16;
  if (viewportWidth < DESKTOP_MIN_WIDTH) return 20;
  return 20;
};
